import { ColumnDetails, ColumnType } from '../../../../../../../../grid/types/common';
import { translateFn } from '../../../../../../../../utils/translator.helper';
import { getDataProtectionRuleTypeGridValues } from '../../../../../utils/uiSettings/contentControl/content-control.values';
import { html, TemplateResult } from 'lit';
import { ContentControlDataProtectionRule } from '@nirvana/shared/dtos/types/policies/common';

export enum Column {
  NAME = 1,
  TYPE,
  STRING,
}

export enum ColumnKeys {
  NAME = 'name',
  TYPE = 'type',
  STRING = 'string',
}

export const GRID_COLUMNS = [Column.NAME, Column.TYPE, Column.STRING];

export const FILTERS = [
  { [ColumnKeys.NAME]: { contains: '' } },
  { [ColumnKeys.TYPE]: { in: [] } },
  { [ColumnKeys.STRING]: { contains: '' } },
];
export const PREDEFINED_FILTERS_KEYS = [ColumnKeys.NAME, ColumnKeys.TYPE, ColumnKeys.STRING];

export function getGridColumnDetails(): Array<ColumnDetails<Column, ColumnKeys>> {
  return [
    {
      column: Column.NAME,
      key: ColumnKeys.NAME,
      columnName: translateFn('Name'),
      type: ColumnType.STRING,
      removable: false,
      filteringDisabled: true,
      sortable: true,
    },
    {
      column: Column.TYPE,
      key: ColumnKeys.TYPE,
      columnName: translateFn('Type'),
      type: ColumnType.ENUM,
      values: getDataProtectionRuleTypeGridValues(),
      removable: false,
      filteringDisabled: true,
      sortable: true,
      editingDisabled: true,
    },
    {
      column: Column.STRING,
      key: ColumnKeys.STRING,
      columnName: translateFn('Filters'),
      type: ColumnType.STRING,
      removable: false,
      filteringDisabled: true,
      sortable: true,
    },
  ];
}

export function nameCellCustomRenderer(
  dispatchClickEventFn: (item) => void,
  rowData: unknown & { item: ContentControlDataProtectionRule }
): TemplateResult {
  return html` <span
    class="accent cell-label"
    style="cursor: pointer"
    @click="${() => dispatchClickEventFn(rowData.item)}"
    >${rowData.item.name}</span
  >`;
}
